/*
 * Project: LegalPlace assistant
 * File: src\components\misc\hidden.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
 */

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { initOutputOption, initOutputVariable } from '../../redux/actions/output';
import { lpGetOptionById, lpGetVariableById } from '../../logic/re_index';


class SingleHidden extends Component {
  componentWillMount() {
    if (!this.props.exists) {
      if (this.props.isDuplicate) {
        this.props.initializeOutput(`${this.props.id}_${this.props.copy}`, this.props.parentId, this.props.ovc, this.props.label);
      } else {
        this.props.initializeOutput(
          this.props.id,
          this.props.parentId,
          this.props.ovc,
          this.props.label,
        );
      }
    }
  }

  render() {
    return (<input type="hidden" value={this.props.label} />);
  }
}

const mapStateToProps = (state, ownProps) => {
  let exists = false;
  const realId = ownProps.isDuplicate ? `${ownProps.id}_${ownProps.copy}` : ownProps.id;
  if (ownProps.ovc === 'o') {
    if (typeof lpGetOptionById(realId) !== 'undefined') {
      exists = true;
    }
  }
  if (ownProps.ovc === 'v') {
    if (typeof lpGetVariableById(realId) !== 'undefined') {
      exists = true;
    }
  }
  return {
    exists,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  initializeFlat: (id) => {
    if (ownProps.ovc === 'o') dispatch(initOutputOption(id, ownProps.lpKey, 'NONE'));
    if (ownProps.ovc === 'v') dispatch(initOutputVariable(id, ownProps.lpKey, 'NONE'));
    return null;
  },
  initializeOutput: (id, parent, genre, value = '') => {
  // console.log("Init statics " + id)
    if (genre === 'o') dispatch(initOutputOption(id, parent, value));
    else if (genre === 'v') dispatch(initOutputVariable(id, parent, value));
  },
});

const LpSingleHidden = connect(mapStateToProps, mapDispatchToProps)(SingleHidden);

export default LpSingleHidden;



// WEBPACK FOOTER //
// ./src/components/misc/hidden.js